var _excluded = ["components", "theme", "size", "colorScheme", "isDisabled", "isInvalid", "inputId", "tagVariant", "hasStickyGroupHeaders", "selectedOptionStyle", "selectedOptionColor", "focusBorderColor", "errorBorderColor", "chakraStyles", "onFocus", "onBlur"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useColorModeValue, useFormControl } from "@chakra-ui/react";
import chakraComponents from "./chakra-components";

var useChakraSelectProps = _ref => {
  var _props$ariaInvalid;

  var {
    components = {},
    theme,
    size = "md",
    colorScheme = "gray",
    isDisabled,
    isInvalid,
    inputId,
    tagVariant,
    hasStickyGroupHeaders = false,
    selectedOptionStyle = "color",
    selectedOptionColor = "blue",
    focusBorderColor,
    errorBorderColor,
    chakraStyles = {},
    onFocus,
    onBlur
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  // Combine the props passed into the component with the props that can be set
  // on a surrounding form control to get the values of `isDisabled` and
  // `isInvalid`
  var inputProps = useFormControl({
    id: inputId,
    isDisabled,
    isInvalid,
    onFocus,
    onBlur
  }); // The chakra UI global placeholder color
  // https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/styles.ts#L13

  var placeholderColor = useColorModeValue("gray.400", "whiteAlpha.400"); // Ensure that the size used is one of the options, either `sm`, `md`, or `lg`

  var realSize = size;
  var sizeOptions = ["sm", "md", "lg"];

  if (!sizeOptions.includes(size)) {
    realSize = "md";
  } // Ensure that the tag variant used is one of the options, either `subtle`,
  // `solid`, or `outline` (or undefined)


  var realTagVariant = tagVariant;
  var tagVariantOptions = ["subtle", "solid", "outline"];

  if (tagVariant !== undefined) {
    if (!tagVariantOptions.includes(tagVariant)) {
      realTagVariant = "subtle";
    }
  } // Ensure that the tag variant used is one of the options, either `subtle`,
  // `solid`, or `outline` (or undefined)


  var realSelectedOptionStyle = selectedOptionStyle;
  var selectedOptionStyleOptions = ["color", "check"];

  if (!selectedOptionStyleOptions.includes(selectedOptionStyle)) {
    realSelectedOptionStyle = "color";
  } // Ensure that the color used for the selected options is a string


  var realSelectedOptionColor = selectedOptionColor;

  if (typeof selectedOptionColor !== "string") {
    realSelectedOptionColor = "blue";
  }

  var select = _objectSpread(_objectSpread({
    // Allow overriding of custom components
    components: _objectSpread(_objectSpread({}, chakraComponents), components),
    // Custom select props
    colorScheme,
    size: realSize,
    tagVariant: realTagVariant,
    selectedOptionStyle: realSelectedOptionStyle,
    selectedOptionColor: realSelectedOptionColor,
    hasStickyGroupHeaders,
    placeholderColor,
    chakraStyles,
    focusBorderColor,
    errorBorderColor,
    // Extract custom props from form control
    onFocus: inputProps.onFocus,
    onBlur: inputProps.onBlur,
    isDisabled: inputProps.disabled,
    isInvalid: !!inputProps["aria-invalid"],
    inputId: inputProps.id
  }, props), {}, {
    // aria-invalid can be passed to react-select, so we allow that to
    // override the `isInvalid` prop
    "aria-invalid": ((_props$ariaInvalid = props["aria-invalid"]) !== null && _props$ariaInvalid !== void 0 ? _props$ariaInvalid : inputProps["aria-invalid"]) ? true : undefined
  });

  return select;
};

export default useChakraSelectProps;
//# sourceMappingURL=use-chakra-select-props.js.map